import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { api } from './api';
import './auth';
import './batches';

// Dedicated store for the ported warehouse screens - kept separate from
// the admin app's store so the RTK Query cache and middleware stay
// isolated. Provider is mounted by components/Warehouse/WarehouseApp.
export const warehouseStore = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(api.middleware),
});

// Enables refetchOnFocus/refetchOnReconnect behaviors for RTK Query
setupListeners(warehouseStore.dispatch);
